<template>
  <div class="price">
    <div v-if="forFree">
      <span v-if="text">Kostenlos</span>
      <span v-else>{{ 0 | currency }}</span>
    </div>

    <div v-else-if="hasDiscount">
      <span class="title">{{ title }}</span>
      <span class="text-danger price-size">{{ discounted | currency }}</span>
      <span><s><small>{{ total | currency }}</small></s></span>
    </div>

    <div v-else>
      <span class="title">{{ title }}</span> {{ total | currency }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    discounted: {
      type: Number,
      default: 0
    },
    total: {
      type: Number,
      default: 0
    },
    text: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: null
    }
  },
  computed: {
    forFree () {
      return !this.total || this.total === 0
    },
    hasDiscount () {
      return this.discounted && this.discounted < this.total
    }
  }
}
</script>
<style>
.price {
  font-size: 20px;
}
</style>
